export const COMMUNITY_ID = "communityId";
export const SELECTION_CRITERIA = "selectionCriteria";
export const DATE_RANGE = "dateRange";
export const YEAR = "year";
export const SOURCE = "source";
export const DOC_NO = "docNo";
export const VENDOR = "vendorIds";
export const OWNER = "ownershipIds";
export const INVOICE_NO = "invoiceNo";
export const PROPERTY = "propertyIds";
export const REPORT_TYPE = "reportType";

export const LEDGER = "LEDGER";
export const COST_ANALYTICS = "COST_ANALYTICS";
export const OWNER_OPTION = "Owner";
export const VENDOR_OPTION = "Vendor";
export const MONTHLY = "monthly";
export const YEARLY = "yearly";

export const selectionCriteriaOptions = [
  { value: MONTHLY, label: "Monthly" },
  { value: YEARLY, label: "Yearly" },
];

export const sourceOptions = [
  { value: LEDGER, label: "Ledger" },
  { value: COST_ANALYTICS, label: "Cost Analytics" },
];

export const reportTypeOptions = [
  { value: "all", label: "All" },
  { value: VENDOR_OPTION, label: "Vendor" },
  { value: OWNER_OPTION, label: "Owner" },
];

export const lineItemColumnOptions = [
  { key: "postingDate", label: "Posting Date", checked: true },
  { key: "documentDate", label: "Document Date", checked: true },
  { key: "documentNumber", label: "Document Number", checked: true },
  { key: "lineNumber", label: "Line item id", checked: true },
  { key: "documentType", label: "Doc Type", checked: true },
  { key: "itemText", label: "Line item text", checked: true },
  { key: "debitAmount", label: "Debits", checked: true },
  { key: "creditAmount", label: "Credits", checked: true },
  { key: "costCenter", label: "Cost Center", checked: false },
  { key: "postingPeriod", label: "Posting Period", checked: false },
  { key: "currency", label: "Currency", checked: false },
  { key: "reference", label: "Reference", checked: false },
];